import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import {loader, toastr} from '../CommonActions';
import { auth} from '../../../services';

export const GET_SUBSCRIPTIONS_FROM_USER = 'GET_SUBSCRIPTIONS_FROM_USER';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';

const successColor =  "success";
const errorColor = "danger";
const warningColor = "warning";

export function fetchSubscriptionFromUser(membershipId) {
	return function(dispatch) {
        dispatch(loader(true));

		var url = `${ROOT_API_URL}/MagazineSubscriptions/GetMagazineSubscriptions?membershipId=${membershipId}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url,options)
			.then((response) => {
				dispatch({
					type: GET_SUBSCRIPTIONS_FROM_USER,
					payload: response.data
                });
				dispatch(loader(false));
			})
			.catch((error) => {
				var err = "Network Connection Error"; 
				dispatch(loader(false));		
				dispatch(toastr(true,err, errorColor));
			});
	};
}

export function updateSubscription(model) {
	return function(dispatch) {
		dispatch(loader(true));
		var url = `${ROOT_API_URL}/MagazineSubscriptions/UpdateMagazineSubscription`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.post(url, model, options)
			.then((response) => {
			if (response && response.data && response.data.issuccess) 
			{
					dispatch({
						type: UPDATE_SUBSCRIPTION,
						payload: response.data.magazineSubscriptions
					});	
					var success = response && response.data ? response.data.message : "Subscription Updated Successfully"; 
					dispatch(toastr(true,success, successColor));
			}
			else {
				var err = response && response.data ? response.data.message : "Error Occured"; 
					dispatch(toastr(true,err, warningColor));
			}
			dispatch(loader(false));
		})
		.catch((response) => {
			var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
		});
	};
}